export default "__VITE_ASSET__DclLSsH4__"